import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIExpirationsHelpers } from './UIExpirationsHelper';

const ExpirationsContext = createContext();
const { initialFilter } = UIExpirationsHelpers();

export function useExpirationsContext () {
    return useContext(ExpirationsContext);
}

export const ExiprationsUIConsumer = ExpirationsContext.Transaction;

export function ExpirationsProvider ({ transactionsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const collection = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        collection
    };

    return <ExpirationsContext.Provider value={value}>{children}</ExpirationsContext.Provider>;
}
